import { logError } from '../logger/logUtils';

type ParsedJWT = {
  userGUID?: string;
  user_name?: string;
  exp?: number;
  status?: string;
};

export function parseJwt(token: string): ParsedJWT {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );

    return JSON.parse(jsonPayload);
  } catch (error: unknown) {
    logError(`parseJwt ${(error as Error)?.message ?? error}`);
  }
  return {};
}
